function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M50.54 30.994c0 12.998-10.537 23.534-23.534 23.534-12.998 0-23.534-10.537-23.534-23.534 0-12.998 10.537-23.534 23.534-23.534m2.353-5.648A23.456 23.456 0 0146 8.704m-2.352 5.648a23.46 23.46 0 016.893 16.641",
  strokeLinecap: "square",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M47.802 30.994c0 11.485-9.31 20.796-20.796 20.796-11.485 0-20.796-9.31-20.796-20.796 0-11.485 9.31-20.796 20.796-20.796m2.73-6.035a20.732 20.732 0 0114.705 6.091m-2.73 6.035a20.73 20.73 0 016.09 14.705",
  strokeLinecap: "square",
  strokeWidth: 1.002
}), /*#__PURE__*/React.createElement("path", {
  d: "M27.006 6.988V55M51.012 30.994H3M43.981 47.969l-33.95-33.95M10.031 47.969l33.95-33.95M29.359 1.811l.122 23.064L46 8.705"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "square",
  strokeWidth: 1.002
}, /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 24.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11.5,
  cy: 36.9,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41.5,
  cy: 24.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 41.5,
  cy: 36.9,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(90.497)",
  cx: 44.864,
  cy: -21.19,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  transform: "rotate(90.497)",
  cx: 44.864,
  cy: -33.59,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 21.5,
  cy: 16.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 10.5,
  r: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18.033,
  cy: 27.49,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 18.338,
  cy: 34.043,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23.348,
  cy: 39.338,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 30.262,
  cy: 39.338,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 34.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 35.5,
  cy: 26.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 33.5,
  cy: 16.5,
  r: 0.5
}), /*#__PURE__*/React.createElement("circle", {
  cx: 23.195,
  cy: 22.119,
  r: 0.5
})));

var SvgPizza = function SvgPizza(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPizza, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Pizza.b645b327.svg";
export { ForwardRef as ReactComponent };